import { BaseSidebarObject } from '@y42/gojs';
import { ILockedNode, IZOrderableNode } from '../../common/models/node.interfaces';

export class FreeDrawNode extends BaseSidebarObject implements ILockedNode, IZOrderableNode {
  constructor(
    public key = '',
    public category = '',
    public geometry = '',
    public borderColor = '',
    public borderWidth = 1,
    public locked = false,
    public location = '0 0',
    public layerName = '',
    public zOrder = NaN,
  ) {
    super();
  }
}
